import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-image-gallery/styles/css/image-gallery.css";
import store from "./state/createStore";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { CodeSearchProvider } from "./context/CodeSearchProvider";

let environment = "";
let dsn = "";

if (
  import.meta.env.VITE_APP_ENV !== "dev" &&
  import.meta.env.VITE_APP_ENV !== "development" &&
  import.meta.env.VITE_APP_ENV !== "local"
) {
  environment = import.meta.env.VITE_APP_SENTRY_ENV;
}

if (
  import.meta.env.VITE_APP_ENV !== "dev" &&
  import.meta.env.VITE_APP_ENV !== "development" &&
  import.meta.env.VITE_APP_ENV !== "local"
) {
  dsn = import.meta.env.VITE_APP_SENTRY_DSN;
}

Sentry.init({
  environment: environment,
  dsn: dsn,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.02,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <CodeSearchProvider>
        <App />
      </CodeSearchProvider>
    </React.Fragment>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
